export default __webpack_public_path__ + "static/media/outline_notification_important_black_48dp 1.8f517ff2.svg";